export interface TocItem {
  id: string;
  text: string;
}

/** Ajoute un id à chaque <h2> et extrait le sommaire (ids déterministes sec-N). */
export function buildToc(html: string): { html: string; toc: TocItem[] } {
  const toc: TocItem[] = [];
  let i = 0;

  const out = html.replace(
    /<h2(\b[^>]*)>([\s\S]*?)<\/h2>/g,
    (_match: string, attrs: string, inner: string) => {
      i += 1;
      const id = `sec-${String(i)}`;
      const text = inner.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
      toc.push({ id, text });
      return `<h2 id="${id}"${attrs}>${inner}</h2>`;
    },
  );

  return { html: out, toc };
}
